/**
 *
 * NewTreatmentUserStep
 *
 */
import { Component } from "react";
import * as PropTypes from "prop-types";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import { createStructuredSelector } from "reselect";
import { compose } from "redux";
import StepArrows from "components/MultiStep/StepArrows";
import GlobalMessages from "messages/messages";
import styled from "styled-components";
import {
  makeSelectEditingTreatment,
  makeSelectPatient,
  makeSelectPatientFailed,
  makeSelectPatientStepInProgress,
  makeSelectUserStepLoading,
} from "containers/NewTreatmentPage/selectors";
import {
  getPatientAction,
  removePatientAction,
  setPatientAction,
  updatePatientAction,
} from "containers/NewTreatmentPage/actions";
import {
  contentWidth,
  FieldWrapper,
  WarningMessages,
} from "basicComponents/FormComponents/FormComponents";
import Search from "basicComponents/Searchv2/Searchv2";
import { makeSelectFilteredPatients } from "containers/App/selectors";
import {
  createDentistAction,
  createPatientAction,
  filterPatientsAction,
  resetPatients,
} from "containers/App/actions";
import ConfirmModal from "basicComponents/ConfirmModal/ConfirmModal";
import messages from "./messages";
import { makeSelectPractice } from "../../PracticePage/selectors";
import PatientInfo from "./PatientInfo";
import history from "../../../utils/history";
import NewTreatmentHeader from "../../NewTreatmentHeader/NewTreatmentHeader";
import { PatientOverviewPage } from "../../PatientOverviewPage/PatientOverviewPage";
import PatientPreview from "basicComponents/PatientPreview";
import DocumentOrderModal from "../../ProductQuestionFlow/DocumentOrderModal";

export class NewTreatmentUserStep extends Component {
  static propTypes = {
    onBack: PropTypes.func.isRequired,
    onNext: PropTypes.func.isRequired,
    insurers: PropTypes.array.isRequired,
    dentists: PropTypes.array.isRequired,
    practice: PropTypes.object.isRequired,
    createPatient: PropTypes.func.isRequired,
    failedMessages: PropTypes.object.isRequired,
    setPatient: PropTypes.func.isRequired,
    removePatient: PropTypes.func.isRequired,
    patient: PropTypes.object,
    inProgress: PropTypes.bool,
    loading: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
    resetPatients: PropTypes.func.isRequired,
    updatePatient: PropTypes.func.isRequired,
    hasPatient: PropTypes.bool.isRequired,
    editingTreatment: PropTypes.bool.isRequired,
  };

  state = {
    patientId: "",
    insuranceNumber: "",
    internalRef: "",
    insurer: null,
    dentist: null,
    insurerIndex: -1,
    dentistIndex: -1,
    patientSelected: false,
    nextClicked: false,
    showOverview: false,
  };

  patientTimeout = -1;

  resetFields() {
    this.setState({
      insuranceNumber: "",
      internalRef: "",
      insurerIndex: -1,
      dentistIndex: -1,
      insurer: null,
      dentist: null,
    });
  }

  componentDidMount() {
    const { patient } = this.props;

    if (patient) {
      this.buildStateFromPatient(patient);
    }
  }

  buildStateFromPatient(patient) {
    const dentists = this.getDentists();
    const insurers = this.getInsurers();
    const insurerIndex = insurers.findIndex(
      insurer => insurer.id === patient.careId,
    );
    const dentistIndex = dentists.findIndex(
      dentist => dentist.id === patient.dentistId,
    );

    this.setState({
      patientId: patient.name,
      insuranceNumber: patient.insuranceNumber || "",
      internalRef: patient.internalRef || "",
      insurerIndex,
      dentistIndex,
      insurer: insurers[insurerIndex],
      dentist: dentists[dentistIndex],
      patientSelected: true,
      // showCancelTreatmentModal: false,
    });
  }

  /**
   * Get the list of insures from props, including "other".
   */
  getInsurers() {
    const insurers = this.props.insurers.slice();
    insurers.unshift({
      id: null,
      name: this.props.intl.formatMessage(GlobalMessages.other),
    });
    return insurers;
  }

  getDentists() {
    const dentists = this.props.dentists.slice();
    dentists.unshift({
      id: null,
      name: this.props.intl.formatMessage(GlobalMessages.other),
    });
    return dentists;
  }

  handleInsurerChanged = (name, index) => {
    const insurer = this.getInsurers()[index];
    this.setState({
      insurer,
      insurerIndex: index,
    });
  };

  handleDentistChanged = (name, index) => {
    const dentist = this.getDentists()[index];
    this.setState({
      dentist,
      dentistIndex: index,
    });
  };

  handleNextClicked = () => {
    if (this.props.inProgress) {
      return;
    }
    // this.props.resetDentists();

    if (this.state.insurer || this.state.dentist)
      this.setState({
        nextClicked: true,
      });

    this.save(() => {
      this.props.onNext();
    });
  };

  handleBackClicked = () => {
    this.props.resetPatients();
    history.push("/treatment/new");
    this.setState({
      patientSelected: false,
    });
    this.resetFields();
  };

  save(callback) {
    const patient = {
      name: this.state.patientId,
      practiceId: this.props.practice.id,
      internalRef: this.state.internalRef,
      careId: this.state.insurer.id,
      insuranceNumber: this.state.insuranceNumber,
      dentistId: this.state.dentist.id,
    };

    if (this.hasPatient) {
      callback();
      return;
    }

    this.props.createPatient(patient, callback, this.hasPatient);
  }

  handlePatientFilterChanged = (filter, kip) => {
    if (this.patientTimeout !== -1) {
      clearTimeout(this.patientTimeout);
    }

    this.patientTimeout = setTimeout(() => {
      this.props.filterPatients({ filter }, kip);
    }, 400);
  };

  handlePatientIdChanged = e => {
    this.setState({ patientId: e.target.value });

    if (e.target.value.length <= 0) {
      this.props.resetPatients();
    } else {
      this.handlePatientFilterChanged(e.target.value, this.props.practice.id);
    }
  };

  handlePatientClicked = (e, column) => {
    const patient = column.original;
    history.push({
      pathname: "/treatment/edit",
      state: { ...history.location.state },
    });
    this.setState({
      patientSelected: true,
      showOverview: false,
    });
    this.props.setPatient(patient);
    this.buildStateFromPatient(patient);
  };

  handleNameChanged = e => {
    this.setState({
      patientId: e.target.value,
    });
  };

  handleInsuranceNumberChanged = e => {
    this.setState({
      insuranceNumber: e.target.value,
    });
  };

  handleInternalRefChanged = e => {
    this.setState({
      internalRef: e.target.value,
    });
  };

  get hasPatient() {
    return !!this.props.patient;
  }

  handleNewPatient = () => {
    const { patientId = "" } = this.state;
    this.resetFields();

    let extraState = {
      patientId: this.state.patientId,
    };

    if (parseInt(patientId.replace(/-|_|#|\/|\s/g, ""), 10)) {
      extraState = {
        internalRef: patientId,
        patientId: "",
      };
    }
    this.setState({
      patientSelected: true,
      showOverview: false,
      ...extraState,
    });
    this.props.removePatient();
  };

  handleUpdatePatient = patient => {
    this.buildStateFromPatient(patient);
    this.props.updatePatient(patient);
  };

  changePatient = () => {
    this.resetFields();
    this.setState({
      patientSelected: false,
    });
    this.props.removePatient();
  };

  isRightTransparent() {
    return this.state.nextClicked || !this.state.insurer || !this.state.dentist;
  }

  showPatientOverview = () => {
    this.setState({ showOverview: !this.state.showOverview });
  };

  renderExisting = () => <PatientPreview patient={this.props.patient} />;

  renderNew = () => {
    const insurers = this.getInsurers().map(insurer => insurer.name);
    const dentists = this.getDentists().map(dentist => dentist.name);

    return (
      <PatientInfo
        onNameChanged={this.handleNameChanged}
        onInternalRefChanged={this.handleInternalRefChanged}
        internalRef={this.state.internalRef}
        onInsurerChanged={this.handleInsurerChanged}
        onDentistChanged={this.handleDentistChanged}
        insurerIndex={this.state.insurerIndex}
        dentistIndex={this.state.dentistIndex}
        insuranceNumber={this.state.insuranceNumber}
        onInsuranceNumberChanged={this.handleInsuranceNumberChanged}
        insurers={insurers}
        dentists={dentists}
        patient={{
          name: this.state.patientId,
        }}
        createDentist={this.props.createDentist}
        practice={this.props.practice}
      />
    );
  };

  render() {
    const { failedMessages } = this.props;
    const showSearch = !this.state.patientSelected && !this.state.showOverview;
    return (
      <>
        <DocumentOrderModal
          onClose={this.props.handleCloseModal}
          title={
            <FormattedMessage
              {...GlobalMessages.dataNotSavedModalAppointmentTitle}
            />
          }
          isOpen={this.props.showModal}
          onConfirm={this.props.onClose}
          content={
            <FormattedMessage
              {...GlobalMessages.are_you_sure_you_want_to_go_back}
            />
          }
        />
        <NewTreatmentHeader onClose={this.props.handleModalOpen} />
        <StepArrows
          fullWidth
          leftDisabled={this.props.loading || !this.state.patientSelected}
          rightDisabled={this.props.loading || !this.state.patientSelected}
          rightTransparent={this.isRightTransparent()}
          onNext={this.handleNextClicked}
          onBack={this.handleBackClicked}
        >
          {!this.props.loading && (
            <Container>
              {showSearch && (
                <>
                  <FieldWrapper>
                    <Search
                      iconButtonText={
                        <FormattedMessage {...messages.addPatient} />
                      }
                      enableIcons={false}
                      height={300}
                      id="patientId"
                      noResultButtonId="addNewPatientButton"
                      onClick={this.handlePatientClicked}
                      value={this.state.patientId}
                      handleUglyButtonClicked={this.handleNewPatient}
                      enableUglyLongButton={this.state.patientId.length >= 2}
                      error={failedMessages.name}
                      items={this.props.filteredPatients}
                      placeholder={messages.searchPatient}
                      onFilter={this.props.onFilter}
                      practice={this.props.practice}
                      showArrow
                      handleArrowClicked={this.showPatientOverview}
                      showTableContent={!!this.state.patientId}
                      onChange={this.handlePatientIdChanged}
                      headers={[
                        {
                          Header: (
                            <FormattedMessage {...GlobalMessages.patientId} />
                          ),
                          accessor: "name",
                          minWidth: 100,
                        },
                        {
                          Header: (
                            <FormattedMessage
                              {...GlobalMessages.internal_ref}
                            />
                          ),
                          accessor: "internalRef",
                          minWidth: 150,
                        },
                        {
                          Header: (
                            <FormattedMessage {...GlobalMessages.caseNr} />
                          ),
                          accessor: "caseId",
                          minWidth: 100,
                        },
                      ]}
                    />
                  </FieldWrapper>
                  <FieldWrapper>
                    <WarningMessages messages={failedMessages.messages} />
                  </FieldWrapper>
                </>
              )}
              {this.state.showOverview && (
                <PatientOverviewPage
                  fromNewAppointment
                  onPatientClicked={this.handlePatientClicked}
                  onHandleNewPatient={this.handleNewPatient}
                  searchedName={this.state.patientId}
                  enableIcons={false}
                  practice={this.props.practice}
                />
              )}
              {this.state.patientSelected &&
                (/.*edit.*/.test(history.location.pathname)
                  ? this.renderExisting()
                  : this.renderNew())}
            </Container>
          )}
        </StepArrows>
      </>
    );
  }
}

const Container = styled.div`
  min-width: 400px;
  ${contentWidth};
  ${({ theme }) => theme.phone`
    min-width: 0;
    width: 100%;
  `};
`;

const mapStateToProps = createStructuredSelector({
  failedMessages: makeSelectPatientFailed(),
  patient: makeSelectPatient(),
  loading: makeSelectUserStepLoading(),
  inProgress: makeSelectPatientStepInProgress(),
  filteredPatients: makeSelectFilteredPatients(),
  practice: makeSelectPractice(),
  editingTreatment: makeSelectEditingTreatment(),
});

function mapDispatchToProps(dispatch) {
  return {
    resetPatients: () => dispatch(resetPatients()),
    setPatient: patient => dispatch(setPatientAction(patient)),
    removePatient: () => dispatch(removePatientAction()),
    createPatient: (patient, callback, existing) =>
      dispatch(createPatientAction(patient, callback, existing)),
    filterPatients: (text, practiceId) =>
      dispatch(filterPatientsAction(text, practiceId)),
    createDentist: (dentist, callback, existing) =>
      dispatch(createDentistAction(dentist, callback, existing)),
    updatePatient: patient => dispatch(updatePatientAction(patient)),
    getPatient: patient => dispatch(getPatientAction(patient)),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default injectIntl(compose(withConnect)(NewTreatmentUserStep));
